<div class="price-table" [class.showDetails]="showDetails">
  @if (discountPrice) {
    <div>{{ formatPrice(discountPrice * amount) }}</div>
  }

  <div class="text" [class.old]="!!discountPrice">
    @if (commercePrice && commercePrice > 0) {
      <div>{{ formatPrice(commercePrice * amount) }}</div>
    }
    @if ((!commercePrice || commercePrice === 0) && (!product.price || product.price === 0)) {
      <div i18n="@@ViaRequest" class="price-via-request">по&nbsp;запросу</div>
    }
    @if ((!commercePrice && commercePrice === 0) && (product.price && product.price !== 0)) {
      <div>{{ formatPrice(product.price * amount) }}</div>
    }

    @if (discount > 0) {
      <tui-icon icon="circle-alert" nbTooltip="Скидка: {{discount}}%"/>
    }
  </div>

  @if (!authService.isAnonymous() && commercePrice < product.price && commercePrice > 0) {
    <div class="old">
      {{ formatPrice(product.price) }}
    </div>
  }
</div>
